import { canUseBackgroundEffects } from '../../../../modules/core';
import { store } from '../../../../store/store';
import { RootScopeEvents } from '../../root-scope-types';
import AbstractTrack from '../abstract.track';
export default class SessionStartedTrack extends AbstractTrack {
    constructor() {
        super(...arguments);
        this.eventNameSegment = 'Session Started';
    }
    start() {
        this.$rootScope.$on(RootScopeEvents.PHONE.START, (_, trackData = {}) => {
            const backgroundEffect = canUseBackgroundEffects()
                ? store.getState().call.backgroundEffect.name
                : null;
            const vendor = { vendor: 'Vonage', isApollo: false };
            this.trackSegment({ ...trackData, ...vendor, backgroundEffect });
        });
    }
}
